import * as React from "react";

const SendMessageIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    width="512"
    height="512"
    x="0"
    y="0"
    version="1.1"
    viewBox="0 0 512.308 512.308"
  >
    <path d="M505.878 36.682 110.763 431.69a63.3 63.3 0 0 0 27.413 6.4h67.669a21.19 21.19 0 0 1 15.083 6.251l36.672 36.651a106.04 106.04 0 0 0 75.157 31.317 107.3 107.3 0 0 0 34.261-5.653c38.05-12.475 65.726-45.46 71.403-85.099l72.085-342.4a63.12 63.12 0 0 0-4.628-42.475M433.771 1.652 92.203 73.61C33.841 81.628-6.971 135.44 1.047 193.802a106.67 106.67 0 0 0 30.228 60.885l36.651 36.651a21.34 21.34 0 0 1 6.251 15.104v67.669a63.3 63.3 0 0 0 6.4 27.413L475.627 6.41a62.53 62.53 0 0 0-41.856-4.758"></path>
  </svg>
);

export default SendMessageIcon;
